import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAppealRequest } from './firebase';
import {
  STATUS_IDLE,
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY
} from './constants';

export const fetchAppealRequests = createAsyncThunk('fetchAppealRequests', async () => await getAppealRequest());

const appealRequestSlice = createSlice({
  name: 'appealRequest',
  initialState: {
    status: STATUS_IDLE,
    data: null
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchAppealRequests.pending, (state, action) => {
        state.status = STATUS_FETCHING
      })
      .addCase(fetchAppealRequests.fulfilled, (state, action) => {
        state.status = STATUS_READY
        state.data = action.payload
      })
      .addCase(fetchAppealRequests.rejected, (state, action) => {
        state.status = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default appealRequestSlice.reducer
